'use client';

import { useState, useCallback } from 'react';
import SearchBar from '@/components/search/SearchBar';
import SearchFilters from '@/components/search/SearchFilters';
import SearchResults from '@/components/search/SearchResults';
import { searchBible } from '@/lib/api';
import type { SearchResult } from '@/lib/types';

export default function SearchPage() {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [testament, setTestament] = useState('');
  const [selectedBooks, setSelectedBooks] = useState<string[]>([]);
  const [selectedThemes, setSelectedThemes] = useState<string[]>([]);

  const handleSearch = useCallback(
    async (query: string) => {
      setLoading(true);
      try {
        const data = await searchBible(query);
        setResults(data.results);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return (
    <div className="flex h-screen">
      {/* Filter sidebar */}
      <div
        className="w-64 shrink-0 overflow-y-auto p-5"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          borderRight: '1px solid rgba(200, 164, 94, 0.1)',
        }}
      >
        <h2
          className="text-xs font-semibold uppercase tracking-wider mb-4"
          style={{ color: 'var(--text-secondary)' }}
        >
          Filters
        </h2>
        <SearchFilters
          testament={testament}
          onTestamentChange={setTestament}
          selectedBooks={selectedBooks}
          onBooksChange={setSelectedBooks}
          selectedThemes={selectedThemes}
          onThemesChange={setSelectedThemes}
        />
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-y-auto p-6">
        <SearchBar onSearch={handleSearch} resultCount={results.length} />

        <div className="mt-6">
          {loading ? (
            <div className="flex justify-center py-12">
              <div
                className="w-6 h-6 border-2 rounded-full animate-spin"
                style={{
                  borderColor: 'rgba(200, 164, 94, 0.2)',
                  borderTopColor: 'var(--accent-gold)',
                }}
              />
            </div>
          ) : (
            <SearchResults results={results} />
          )}
        </div>
      </div>
    </div>
  );
}
